import { c as _c } from "react/compiler-runtime";
import "@google/model-viewer";
import type { BaseNFT } from "@/entities/INFT";
import { getResolvedAnimationSrc } from "./utils/animation-source";
export default function NFTModel(props) {
  const $ = _c(7);
  const t0 = props.id ?? `iframe-${props.nft.id}`;
  let t1;
  if ($[0] !== props.nft) {
    t1 = getResolvedAnimationSrc(props.nft);
    $[0] = props.nft;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== props.nft.name || $[3] !== props.nft.scaled || $[4] !== t0 || $[5] !== t1) {
    t2 = <model-viewer id={t0} src={t1} alt={props.nft.name} auto-rotate={true} camera-controls={true} ar={true} poster={props.nft.scaled} />;
    $[2] = props.nft.name;
    $[3] = props.nft.scaled;
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}